import Zoom from "../zoom";
import { handleMouseMoveZoom } from "./zoomUtilities";
import { toggleZoom } from "./zoomEvents";
// ==================================
// ======== Funções de popup ========
// ==================================

// Cria o popup no DOM e retorna seus elementos
function createPopup() {
  let popup = document.createElement('div');
  popup.id = 'image-popup';

  let closeButton = document.createElement('button');
  closeButton.classList.add('close-button');

  let imgContainer = document.createElement('div');
  imgContainer.classList.add('image', '-custom', '-loading');

  let zoomedImage = document.createElement('img'); 
  zoomedImage.classList.add('popup-image');

  popup.appendChild(imgContainer);
  popup.appendChild(closeButton);
  imgContainer.appendChild(zoomedImage);

  return { popup, closeButton, imgContainer, zoomedImage };
}

// Trata os eventos do popup
function handlePopupEvents(popup, closeButton, imgContainer, zoomedImage) {
  let isZoomed = false;

  // Fecha o popup (clique no botão ou no background)
  popup.addEventListener('click', (event) => {
    if (event.target === popup || event.target === closeButton) {
      popup.classList.remove('-visible');
      isZoomed = false;
      zoomedImage.style.transform = 'scale(1)';
      zoomedImage.style.transformOrigin = 'center';

      // Remove as classes que controlam a atualização do cursor
      zoomedImage.classList.contains('-zoom-available') 
      && zoomedImage.classList.remove('-zoom-available');

      zoomedImage.classList.contains('-visible-image') 
      && zoomedImage.classList.remove('-visible-image');

    }
  });

  // Adiciona o evento de zoom caso o popup tem seu próprio nível de zoom
  if (Zoom.zoomOnPopup) {
    // Ativa o segundo nível de zoom ao clicar na imagem dentro do popup
    zoomedImage.addEventListener('click', (event) => {
      event.stopPropagation();
      if (!imgContainer || !zoomedImage) return;
      toggleZoom(zoomedImage, isZoomed)
      isZoomed = !isZoomed;

      handleMouseMoveZoom(event, imgContainer, zoomedImage);
    });

    // Remove o zoom quando o mouse sai da imagem
    imgContainer && imgContainer.addEventListener('mouseleave', (event) => {
      if(isZoomed) {
        toggleZoom(zoomedImage, isZoomed);
        isZoomed = !isZoomed;
      }
    });

    // Move a imagem com o mouse no segundo nível de zoom
    imgContainer && imgContainer.addEventListener('mousemove', (event) => {
      if (isZoomed) {
        handleMouseMoveZoom(event, imgContainer, zoomedImage);
      }
    });
  }
}

// Função que trata a exibição do popup da imagem
export function showPopupOnClick(imageSlide) {
  if (!imageSlide || !Zoom.zoomPopupInstance) return;
  // Acessa os elementos da instancia do popup
  const popupZoom = Zoom.zoomPopupInstance;
  const imgContainer = popupZoom.querySelector('.image');
  const zoomedImage = popupZoom.querySelector('.popup-image');
  const imageElement = imageSlide.querySelector('img');
  imgContainer.classList.add('-loading');

  // Troca o src da imagem
  zoomedImage.src = imageElement.getAttribute('data-zoom-src') || imageElement.src;
  zoomedImage.alt = imageElement.alt;
  zoomedImage.onload = () => {
    imgContainer.classList.remove('-loading');
  };


  // Adiciona ou exibe o popup da imagem
  !document.body.contains(popupZoom) && setTimeout(() => document.body.appendChild(popupZoom), 10);
  setTimeout(() => popupZoom.classList.add('-visible'), 50);

  // Adiciona a classe que controla o cursor de zoom,
  // com um intervalo para o navegador identificar a mudança
  Zoom.zoomOnPopup 
  ? setTimeout(() => zoomedImage.classList.add('-zoom-available'), 80)
  : setTimeout(() => zoomedImage.classList.add('-visible-image'), 80);

}

// Função que trata o evento no botão que abre o popup de zoom
export function setPopupButton(image) {
  const { zoomPopup } = Zoom;
  if (!image) return

  // Encontra o botão que abre o popup de zoom
  const zoomPopupButton = image.querySelector('[data-zoom-image]');

  // Quando houver popup e botão de controle de popup
  if (zoomPopup && zoomPopupButton) {
    // Evento de clique no botão para exibir o popup
    zoomPopupButton.addEventListener('click', () => {
      if (Zoom.isZoomActive) toggleZoom(image);
      showPopupOnClick(image);
    })
  } else if (zoomPopupButton && !zoomPopup && !window.mobile) { // Esconde o botão caso não tenha popup
    zoomPopupButton.style.display = 'none';
  }
}

// Cria o popup, faz o tratamento de seus eventos e atribui sua instância a uma propriedade de Zoom
export function handleImagesPopup() {
  const { targetImagesSlider } = Zoom;
  const mainImages = targetImagesSlider.element.querySelectorAll('img');
  if (mainImages.length === 0) return;

  const { popup, closeButton, imgContainer, zoomedImage } = createPopup();
  handlePopupEvents(popup, closeButton, imgContainer, zoomedImage);

  // Armazena a instancia do popup com suas funcionalidades como uma propriedade do objeto
  Zoom.zoomPopupInstance = popup;

}
